'use client'

import NavigationInner from '@/components/Navigation/NavigationInner/NavigationInner'

const Navigation = () => {
  return <NavigationInner />
}

Navigation.displayName = 'Navigation'

export default Navigation
